<template>
  <div :class="varient" class>
    <div class="d-flex align-items-center region">
      <label for="region" class="m-0 fam-roboto-light">Region</label>
      <b-form-select
        id="region"
        v-model="$store.state.Dregion"
        :options="region"
        @change="updateCookie('region', $store.state.Dregion)"
        size="sm"
        class="border-0 p-0"
      ></b-form-select>
    </div>
    <div class="d-flex align-items-center language">
      <label for="language" class="m-0 fam-roboto-light">Language</label>
      <b-form-select
        id="language"
        v-model="$store.state.Dlanguage"
        :options="language"
        @change="updateCookie('language', $store.state.Dlanguage)"
        size="sm"
        class="border-0 p-0"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    varient: {
      type: String,
      default: "nav-section"
    }
  },
  data() {
    return {
      region: [
        { value: "br", text: "Brazil" },
        { value: "ca", text: "Canada" },
        { value: "in", text: "India" },
        { value: "pr", text: "Puerto Rico" },
        { value: "uk", text: "United Kingdom" },
        { value: "us", text: "United States" }
      ],
      language: [{ value: "en", text: "English" }]
    };
  },
  created() {
    if (!this.$cookies.get("CA")) {
      this.$store.state.Dregion = "us";
      this.$store.state.Dlanguage = 'en'
    } else {
      this.$store.state.Dregion = this.$cookies.get("CA").region;
      this.$store.state.Dlanguage = this.$cookies.get('CA').language
    }
  },
  methods: {
    updateCookie(triggLocation, triggerText) {
      this.$store.state.filters = `availableIn:"${this.$store.state.Dregion}"`;
      const preferences = {
        language: this.$store.state.Dlanguage,
        region: this.$store.state.Dregion
      };
      this.$cookies.set("CA", preferences);
    }
  }
};
</script>

<style lang="scss">
.dropdown_icon {
  position: absolute;
  right: 10%;
}
.modal-cookie {
  display: flex;
  flex-direction: column;
  .custom-select {
    background: url("../assets/images/expand-arrow.svg") no-repeat right 0.5rem
      center/8px 10px !important;
    color: white;
    border-bottom: 1px solid white !important;
    border-radius: 0;
    -webkit-appearance: none;
    option {
      color: #000000 !important;
    }
  }
  .language,
  .region {
    padding: 5px 0;
    margin-left: -5%;
  }
  label {
    color: white;
    font-family: "stb-light" !important;
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
    width: 50%;
    align-items: center;
    font-size: 14px;
    text-align: right;
    padding-top: 5px !important;
    &:after {
      content: " :";
    }
  }
}
.mobile-nav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .custom-select {
    background: url("../assets/images/expand-arrow.svg") no-repeat right 1.5rem
      center/8px 10px !important;
    background: none;
    color: white;
    border-radius: 0;
    -webkit-appearance: none;
    font-size: 10px;
    padding: 0 !important;
  }
  .region {
    label {
      width: 60px;
    }
  }
  .language {
    label {
      width: 100px;
    }
  }
  label {
    color: white;
    font-size: 10px;
    padding: 0 !important;
    &:after {
      content: " :";
    }
  }
  #region {
    background-position-x: left 3 !important;
    padding-left: 4px !important;
    &:after {
      color: white;
    }
  }
}
.nav-section {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  .custom-select {
    background-color: transparent;
    color: black;
    height: 25px;
    border-radius: 0;
    font-size: 12px;
    margin-right: 20px;
    -webkit-appearance: none;
    box-shadow: none;
    background: url("../assets/images/expand-arrow-green.svg") no-repeat right
      0rem center/11px 13px !important;
  }
  .language {
    margin-left: 1rem;
  }
  .language,
  .region {
    padding: 5px 0;
    .custom-select {
      padding-right: 15px !important;
    }
  }
  .region {
    &:after {
      color: #55565a;
      font-size: 14px;
    }
  }
  label {
    color: #29413b;
    margin: 0;
    font-family: "Roboto", serif !important;
    font-weight: 200 !important;
    padding-right: 3px;
    font-size: 12px;
    text-align: right;
    &:after {
      content: " :";
    }
  }
}
</style>
